module.exports = __webpack_public_path__ + "static/media/caracolLogo.89f256b1.png";